<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Document-Complaint-Manage",
  short_name: "Manage Complaint Document",
  path: "manage/:id?",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
